import RadioGroup from 'components/elements/molecules/Radio/RadioGroup';
import RadioOption from 'components/elements/molecules/Radio/RadioOption';
import FloatingInput from 'components/elements/atoms/FloatingInput/FloatingInput';
import React from 'react';

export default function SourcePaywallStatusChange({ source, handleFormChange }) {
  const isFree = source.paywallStatus === 'free';
  const isPaid = source.paywallStatus === 'paid';
  const isLimited = source.paywallStatus === 'limited';

  return (
    <React.Fragment>
      <RadioGroup
        name="paywallStatus"
        label="Paywall"
        handleChange={(e) => handleFormChange(e.target.name, e.target.value)}
        errorMessage=""
      >
        <RadioOption
          name="paywallStatus"
          id="paywallStatusFree"
          value="free"
          label="Free"
          checked={isFree}
        />
        <RadioOption
          name="paywallStatus"
          id="paywallStatusLimited"
          value="limited"
          label="Limited Free"
          checked={isLimited}
        />
        <RadioOption
          name="paywallStatus"
          id="paywallStatusPaid"
          value="paid"
          label="Paid"
          checked={isPaid}
        />
      </RadioGroup>
      {isLimited ? (
        <FloatingInput
          value={source.paywallLimit || ''}
          labelName="Free articles per month"
          name="paywallLimit"
          type="number"
          onChange={(e) => handleFormChange(e.target.name, e.target.value)}
          className="mt-2"
        />
      ) : null}
    </React.Fragment>
  );
}
